import {Routes} from '@angular/router'
import {
  adminAuthGuard,
  LoginComponent
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {HOME_ROUTE_PATH, LOGIN_ROUTE_PATH} from './application/data-types'
import {InterestResolver} from './application/interest.resolver'

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_ROUTE_PATH
  },
  {
    path: HOME_ROUTE_PATH,
    loadComponent: () => import('./home/home/home.component').then(m => m.HomeComponent),
    canActivate: [adminAuthGuard],
    resolve: {
      interests: InterestResolver
    }
  },
  {
    path: LOGIN_ROUTE_PATH,
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: LOGIN_ROUTE_PATH
  }
]
